export const labelToColor = label => {
  if (!label || label.length === 0) return 'gray';

  let hash = 0;
  for (let i = 0; i < label.length; i++) {
    hash = label.charCodeAt(i) + ((hash << 5) - hash);
  }

  // hue range around blue (190–260° roughly)
  const hue = 190 + (Math.abs(hash) % 70); // gives 190–260
  const saturation = 70 + (Math.abs(hash) % 20); // 70–90%
  const lightness = 45 + (Math.abs(hash) % 15); // 45–60%

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};
